import { ReactElement, ReactNode } from 'react';
import { Me } from '.';
import { MeContext } from './context';

type Props = {
    readonly me: Me;
    readonly children?: ReactNode;
};
export function MeProvider(props: Props): ReactElement {
    const { me, children } = props;

    return (
        <MeContext.Provider
            value={{
                me
            }}
        >
            {children}
        </MeContext.Provider>
    );
}
